<template>

</template>
<script>
  /**
   * provides shared functionality for Containers rendering items
   */

  import { mapGetters } from 'vuex'

  export default {
    name: 'ItemsContainerMixin',
    computed: {
      itemProperties() {
        let properties = {};
        let that = this;

        // helper function to get property value, which in case that a property is not present
        // will print a warning message to the console
        properties.getProperty = function(propertyName) {
          const property = this[propertyName];

          if (property) {
            return property
          } else {
            if(process.env.NODE_ENV === 'development') {
              console.warn(`Property '${propertyName}' is not configured for item '${that.item.text}'.`)
            }
            return undefined;
          }
        };

        if (this.item.properties){
          this.item.properties.map(property => properties[property.name] = property.value);
          return properties
        } else {
          return properties
        }
      },
    },
  }
</script>
